<template>
  <!-- 巡查任务 -->
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="openAddTaskBox()"
          >添加</el-button
        >
        <el-button
          type="danger"
          size="mini"
          plain
          icon="el-icon-circle-close"
          :disabled="ids.length == 0"
          @click="dailyInspectionBathHide('')"
          >删除</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-open"
          :disabled="ids.length == 0"
          @click="dailyInspectionBatchEnable('')"
          >启用</el-button
        >
        <el-button
          type="warning"
          size="mini"
          plain
          icon="el-icon-turn-off"
          :disabled="ids.length == 0"
          @click="dailyInspectionBatchDisable('')"
          >禁用</el-button
        >
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-top-right"
          @click="exportReport"
          :disabled="dailyInspectionData.list.length == 0"
          >导出</el-button
        >
      </div>
      <div class="search_box">
        <el-input
          size="mini"
          placeholder="请输入任务名称"
          class="textInput"
          v-model.trim="requestParams.dailyTaskName"
        >
        </el-input>
        <el-input
          size="mini"
          placeholder="请输入巡查区域"
          class="textInput"
          v-model.trim="requestParams.regionalPatrolSite"
        >
        </el-input>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData()"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="dailyInspectionData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="selectDailyPatrolTask"
        >
          <el-table-column type="selection" width="40"> </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{
                requestParams.pageSize * (requestParams.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>

          <el-table-column prop="dailyTaskName" label="任务名称" align="center">
          </el-table-column>

          <el-table-column
            prop="taskType.taskType"
            label="任务类型"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{
                $store.state.select.taskType[scope.row.taskType.taskType].name
              }}
            </template>
          </el-table-column>

          <el-table-column
            prop="taskType.taskContent"
            label="任务时间"
            class-name="oneLineHidden"
            width="150px"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="Top Center 提示文字"
                placement="top"
              >
                <div slot="content">
                  <div
                    v-for="(value, key) in scope.row.taskType.taskContent.split(
                      ','
                    )"
                    :key="key"
                    style="padding:.5rem 0"
                  >
                  <div v-if="scope.row.taskType.taskType == 1">
                    <span v-if="value == '1'">{{ $Common.weekTransition(value) }}</span>
                    <span v-else-if="value == '2'">{{ $Common.weekTransition(value) }}</span>
                    <span v-else-if="value == '3'">{{ $Common.weekTransition(value) }}</span>
                    <span v-else-if="value == '4'">{{ $Common.weekTransition(value) }}</span>
                    <span v-else-if="value == '5'">{{ $Common.weekTransition(value) }}</span>
                    <span v-else-if="value == '6'">{{ $Common.weekTransition(value) }}</span>
                    <span v-else-if="value == '7'">{{ $Common.weekTransition(value) }}</span>
                    <span v-else>{{ value }}</span>
                  </div>
                  <span v-else-if="scope.row.taskType.taskType == 2">{{ value }}月</span>
                  <span v-else>{{ value }}</span>
                  </div>
                  <!-- {{scope.row.taskType.taskContent}} -->
                </div>
                <el-button size="small">查看时间</el-button>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column
            prop="regionalPatrol.regionalPatrolSite"
            label="检查地点"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="user.userName"
            label="任务负责人"
            width="100"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="addtime"
            label="创建时间"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ $Common.dateFormatDate(scope.row.addtime) }}
            </template>
          </el-table-column>

          <el-table-column
            prop="dailyTaskStatus"
            label="任务状态"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.dailyTaskStatus == 0">
                <el-tag type="success">启用</el-tag>
              </div>
              <div v-if="scope.row.dailyTaskStatus == 1">
                <el-tag type="warning">禁用</el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="getTaskDetails(scope.row.dailyTaskId)"
                :underline="false"
                :disabled="scope.row.dailyTaskStatus == 1"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      v-if="scope.row.dailyTaskStatus == 1"
                      @click="dailyInspectionBatchEnable(scope.row.dailyTaskId)"
                      :underline="false"
                      >启用</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      v-if="scope.row.dailyTaskStatus == 0"
                      @click="
                        dailyInspectionBatchDisable(scope.row.dailyTaskId)
                      "
                      :underline="false"
                      >禁用</el-link
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="dropdown_item_box"
                    ><el-link
                      class="link_box"
                      type="primary"
                      @click="dailyInspectionHide(scope.row.dailyTaskId)"
                      :underline="false"
                      >删除</el-link
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination_box">
        <el-pagination
          @current-change="dailyInspectionPage"
          :current-page="requestParams.pageNum"
          :page-size="requestParams.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="dailyInspectionData.totalSize"
        >
        </el-pagination>
      </div>

      <!-- 新增巡查任务 -->
      <el-dialog
        :before-close="cancelForm"
        :visible.sync="addTaskDialog"
        direction="ltr"
        custom-class="demo-drawer"
        ref="drawer"
        append-to-body
        size="50%"
        title="新增巡查任务"
        width="800px"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
        <div class="demo-drawer__content ">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 control-label">任务名称</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model.trim="oneTaskData.dailyTaskName"
                  class="form-control"
                  placeholder="任务名称"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">地点名称</label>
              <div class="col-sm-10">
                <select
                  class="form-control"
                  v-model="oneTaskData.regionalPatrolId"
                >
                  <option :value="0">请选择巡查区域</option>
                  <option
                    :value="value.regionalPatrolId"
                    v-for="(value, key) in patrolPointList"
                    :key="key"
                    >{{ value.regionalPatrolSite }}</option
                  >
                </select>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">任务负责人</label>
              <div class="col-sm-10 options_box">
                <el-cascader
                  :options="departmentHead"
                  v-model="testUserInfo.userId"
                  @change="selectDepartmentHead"
                  ref="departmentHeadSelect"
                  filterable
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.label }}</span>
                    <span v-if="!node.isLeaf">
                      ({{ data.children.length }})
                    </span>
                  </template>
                </el-cascader>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label">检查项状态</label>
              <div class="col-sm-10">
                <el-radio-group v-model="oneTaskData.checkMode" size="medium">
                  <el-radio
                    :label="value.id"
                    border
                    v-for="(value, index) in $store.state.select
                      .checkItemStatus"
                    :key="index"
                  >
                    {{ value.nameOne }}
                  </el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label">任务时间类型</label>
              <div class="col-sm-10">
                <div>
                  <el-radio-group
                    v-model="oneTaskData.dailyTaskTimeStatus"
                    size="medium"
                    @change="setRaskTimeType"
                  >
                    <el-radio
                      border
                      v-for="(value, index) in $store.state.select.taskTimeType"
                      :key="index"
                      :label="value.id"
                    >
                      {{ value.nameOne }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-10">
                <el-radio-group
                  v-model="oneTaskData.taskType.taskType"
                  size="medium"
                  @change="temporaryStorageDataInit"
                >
                  <el-radio-button
                    v-for="(value, index) in $store.state.select.taskTimeType[
                      oneTaskData.dailyTaskTimeStatus
                    ].taskTimeTypeList"
                    :key="index"
                    :label="value.id"
                  >
                    {{ value.nameOne }}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <!-- 自定义任务 -->
            <div
              class="form-group"
              v-show="
                oneTaskData.dailyTaskTimeStatus == 0 &&
                  oneTaskData.taskType.taskType == 0
              "
            >
              <div class="col-sm-offset-2 col-sm-10"></div>
              <div class="col-sm-offset-2 col-sm-10">
                <el-date-picker
                  format="yyyy 年 MM 月 dd 日"
                  value-format="yyyy-MM-dd"
                  type="dates"
                  :picker-options="expireTimeOption"
                  v-model="temporaryStorageData.arrayData"
                  placeholder="请选择自定义日期"
                  @change="taskDateSelect"
                >
                </el-date-picker>
              </div>
            </div>
            <!-- 周任务 -->
            <div
              class="form-group"
              v-show="
                oneTaskData.dailyTaskTimeStatus == 0 &&
                  oneTaskData.taskType.taskType == 1
              "
            >
              <div class="col-sm-offset-2 col-sm-10">
                <el-checkbox-group
                  v-model="temporaryStorageData.arrayData"
                  size="medium"
                  @change="taskDateSelect"
                >
                  <el-checkbox-button
                    v-for="(value, index) in weekDayList"
                    :key="index"
                    :label="value.id.toString()"
                  >
                    {{ value.name }}
                  </el-checkbox-button>
                </el-checkbox-group>
              </div>
            </div>
            <!--月任务 指定日期月任务 -->
            <div
              class="form-group"
              v-show="
                oneTaskData.dailyTaskTimeStatus == 0 &&
                  oneTaskData.taskType.taskType == 2
              "
            >
              <div class="col-sm-offset-2 col-sm-10">
                <el-checkbox-group
                  v-model="temporaryStorageData.arrayData"
                  size="medium"
                  @change="taskDateSelect"
                >
                  <el-checkbox
                    style="margin-left:0"
                    border
                    v-for="(value, index) in $store.state.select.monthData"
                    :key="index"
                    :label="value.monthNumber.toString()"
                  >
                    {{ value.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <!-- 当前年份 -->
            <div
              class="form-group"
              v-show="oneTaskData.dailyTaskTimeStatus == 1"
            >
              <div class="col-sm-offset-2 col-sm-10">
                <el-input-number
                  size="medium"
                  v-model="thisYear"
                  label="描述文字"
                  @change="dateInitialization()"
                ></el-input-number>
                <el-button
                  style="margin-left:10px"
                  icon="el-icon-circle-check"
                  size="medium"
                  type="primary"
                  v-if="oneTaskData.taskType.taskType == 1"
                  @click="weekCheckAll"
                  >全选</el-button
                >
                <el-button
                  style="margin-left:10px"
                  icon="el-icon-circle-close"
                  size="medium"
                  type="primary"
                  plain
                  v-if="oneTaskData.taskType.taskType == 1"
                  @click="cancelCheckAll"
                  >取消全选</el-button
                >
              </div>
            </div>

            <!-- 选择第几周 -->
            <div
              class="form-group"
              v-show="
                oneTaskData.dailyTaskTimeStatus == 1 &&
                  oneTaskData.taskType.taskType == 1
              "
            >
              <div class="col-sm-offset-2 col-sm-10">
                <el-checkbox-group
                  v-model="temporaryStorageData.arrayData"
                  size="mini"
                  @change="taskDateSelect"
                >
                  <el-checkbox
                    style="margin-left:0"
                    :checked="value.selectedStatus"
                    border
                    :disabled="value.disable"
                    v-for="(value, index) in weekInitialization"
                    :label="value.dateRange"
                    :key="index"
                  >
                    {{ value.dateName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <!-- 选择月任务 -->
            <div
              class="form-group"
              v-show="
                oneTaskData.dailyTaskTimeStatus == 1 &&
                  oneTaskData.taskType.taskType == 2
              "
            >
              <div class="col-sm-offset-2 col-sm-10">
                <el-checkbox-group
                  v-model="temporaryStorageData.arrayData"
                  size="mini"
                  @change="taskDateSelect"
                >
                  <el-checkbox
                    style="margin-left:0"
                    :checked="value.selectedStatus"
                    border
                    :disabled="value.disable"
                    v-for="(value, index) in monthInitialization"
                    :label="value.dateRange"
                    :key="index"
                  >
                    {{ value.dateName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <!-- 选取季度任务 -->
            <div
              class="form-group"
              v-show="
                oneTaskData.dailyTaskTimeStatus == 1 &&
                  oneTaskData.taskType.taskType == 3
              "
            >
              <div class="col-sm-offset-2 col-sm-10">
                <el-checkbox-group
                  v-model="temporaryStorageData.arrayData"
                  size="mini"
                  @change="taskDateSelect"
                >
                  <el-checkbox
                    style="margin-left:0"
                    :checked="value.selectedStatus"
                    border
                    :disabled="value.disable"
                    v-for="(value, index) in quarterInitialization"
                    :label="value.dateRange"
                    :key="index"
                  >
                    {{ value.dateName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <!-- 学期任务 -->
            <div
              class="form-group"
              v-show="
                oneTaskData.dailyTaskTimeStatus == 1 &&
                  oneTaskData.taskType.taskType == 4
              "
            >
              <div class="col-sm-offset-2 col-sm-10">
                <el-checkbox-group
                  v-model="temporaryStorageData.arrayData"
                  size="mini"
                  @change="taskDateSelect"
                >
                  <el-checkbox
                    style="margin-left:0"
                    :checked="value.selectedStatus"
                    border
                    :disabled="value.disable"
                    v-for="(value, index) in semesterInitialization"
                    :label="value.dateRange"
                    :key="index"
                  >
                    {{ value.dateName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>

            <!-- 巡查人员 -->
            <div v-show="oneTaskData.dailyTaskTimeStatus == 1">
              <div class="form-group">
                <label class="col-sm-2 control-label">巡查人员</label>
                <div class="col-sm-10">
                  <el-radio-group
                    v-model="patrolPersonnel.completeTheWay"
                    size="medium"
                  >
                    <el-radio
                      :label="value.id"
                      border
                      v-for="(value, index) in $store.state.select
                        .typeOfInspector"
                      :key="index"
                    >
                      {{ value.nameOne }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>

              <div class="form-group options_box">
                <div class="col-sm-offset-2 col-sm-10">
                  <tree-common
                    ref="selectTree"
                    @changeDatas="selectPatrolPersonnel"
                    :treeData="departmentHead"
                    :isShow="addTaskDialog"
                    style="width:80%"
                  ></tree-common>
                  <!-- <el-cascader :options="departmentHead" v-model="selectedPersonList" ref="patrolPersonnelSelect"  @change="selectPatrolPersonnel"  :props="props" clearable placeholder="请选择巡查人员" filterable></el-cascader> -->
                </div>
              </div>
            </div>

            <!-- 巡查时段 -->
            <div v-show="oneTaskData.dailyTaskTimeStatus == 0">
              <div class="form-group">
                <label class="col-sm-2 control-label">巡查时段</label>
                <div class="col-sm-10">
                  <el-button
                    type="primary"
                    plain
                    icon="el-icon-circle-plus-outline"
                    size="medium"
                    @click="newTimePeriod"
                  >
                    添加时间段
                  </el-button>
                </div>
              </div>
              <div v-for="(value, key) in inspectionPeriod" :key="key">
                <div class="form-group options_box">
                  <div class="col-sm-offset-2 col-sm-10">
                    <p class="bg-primary" style="padding: 1rem">
                      时间段
                      <b>{{ key + 1 }}</b>
                    </p>
                  </div>
                </div>
                <div class="form-group options_box">
                  <div class="col-sm-offset-2 col-sm-10">
                    <el-time-picker
                      size="medium"
                      is-range
                      v-model="value.timeArray"
                      @change="selectTimeSlot(key)"
                      range-separator="至"
                      format="HH点mm分"
                      value-format="HH:mm"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      placeholder="选择时间范围"
                    >
                    </el-time-picker>
                    <el-button
                      @click="deleteTimePeriod(key)"
                      type="danger"
                      style="float:right"
                      icon="el-icon-circle-close"
                      size="medium"
                    >
                      删除
                    </el-button>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-offset-2 col-sm-10">
                    <el-radio-group
                      v-model="value.completeTheWay"
                      size="medium"
                    >
                      <el-radio
                        :label="index"
                        border
                        v-for="(value, index) in $store.state.select
                          .typeOfInspector"
                        :key="index"
                      >
                        {{ value.nameOne }}
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="form-group options_box">
                  <div class="col-sm-offset-2 col-sm-10" style="font-weight:bold;">
                    添加巡查人：
                  </div>
                </div>
                <div class="form-group options_box">
                  <div class="col-sm-offset-2 col-sm-10">
                    <tree-common
                      :ref="`patrolPersonnelSelect${key}`"
                      @changeDatas="
                        (data) => selectPatrolPersonnelList(data, key)
                      "
                      :treeData="departmentHead"
                      style="width:80%"
                    ></tree-common>
                  </div>
                </div>
                <div class="form-group options_box">
                  <div class="col-sm-offset-2 col-sm-10">
                    <el-divider></el-divider>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <div class="col-sm-offset-2 col-sm-10">
                <el-button
                  type="primary"
                  v-loading="addLoading"
                  v-if="editState == false"
                  @click="newTask"
                  size="medium"
                  >确定提交</el-button
                >
                <el-button
                  type="primary"
                  v-loading="editLoading"
                  v-if="editState == true"
                  @click="editTaskDetails"
                  size="medium"
                  >确定修改</el-button
                >
                <el-button @click="cancelForm()" size="medium">返回</el-button>
              </div>
            </div>
          </form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DailyPatrol from "@/components/DailyPatrol";
import TreeCommon from "./components/SelectTree";

export default {
  name: "",
  components: { DailyPatrol, TreeCommon },
  props: {},
  data() {
    return {
      addLoading:false,
      editLoading:false,
      startTime: "",
      endTime: "",
      weekDayList: [],
      monthDayList: [],

      // dialogList: {
      //   addTaskDialog: false
      // },
      addTaskDialog: false,
      // 请求数据
      requestParams: {
        schoolId: this.$store.state.schoolId,
        pageNum: 1,
        pageSize: 20,
        searchValue: "",
        dailyTaskName: "", // 巡查任务
        regionalPatrolSite: "", // 巡查点
        supervisorsStatus: "" // 巡查状态
      },
      // 日常巡查数据
      dailyInspectionData: {
        pageNum: 1, // 第几页
        pageSize: 20, // 一页多少个
        totalSize: 0, // 总条数
        totalPages: 0, // 总页数
        list: [] // 数据列表
      },
      ids: [],
      // 批量操作数据
      batchOperationData: {
        list: [],
        additionalData: [],
        str: "",
        listTwo: [],
        strTwo: ""
      },
      // 单条巡查任务数据
      oneTaskData: {
        schoolId: this.$store.state.schoolId, // 学校id
        dailyTaskName: "", // 任务名称
        checkMode: 1, // 任务状态 0.正常 1.异常
        regionalPatrolId: 0, // 巡查点id
        dailyTaskTimeStatus: 0, // 任务时间类型 0.指定日期时间段完成1.指定任意时间均可完成
        userId: 0, // 负责人id
        taskType: {
          taskType: 0,
          taskContent: ""
        },
        timeQuantums: [], // 时间段
        timeQuantumList: []
      },
      // 巡查点
      patrolPointList: [],
      // 部门负责人
      departmentHead: [],
      testUserInfo: {
        userId: ""
      },

      // 选择日期开始时间
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() <= Date.now() - 8.64e7;
        }
      },

      // 当前年份
      thisYear: 0,
      // 初始化星期
      weekInitialization: [],
      // 初始化季度
      quarterInitialization: [],
      // 初始化学期
      semesterInitialization: [],
      // 初始化月
      monthInitialization: [],
      // 临时存储的数据
      temporaryStorageData: {
        arrayData: [],
        stringData: ""
      },

      // 检查时间段
      inspectionPeriod: [],
      // 巡查人员
      patrolPersonnel: {
        completeTheWay: 0,
        userNameArray: "", // 用户名称集合逗号隔开
        userIdArray: "", // 用户名称id集合逗号隔开
        timeQuantumId: 0
      },
      props: {
        multiple: true,
        expandTrigger: "hover"
      },
      editState: false,
      loading: false,

      selectedPersonList: []
    };
  },
  watch: {
    inspectionPeriod: {
      handler: function(newVal, oldVal) {
        this.oneTaskData.timeQuantums = newVal;
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    // 清空数据
    clearData() {
      this.oneTaskData.dailyTaskName = "";
      this.oneTaskData.checkMode = 1;
      this.oneTaskData.regionalPatrolId = 0;
      this.oneTaskData.dailyTaskTimeStatus = 0;
      this.oneTaskData.userId = 0;
      this.oneTaskData.taskType = {
        taskType: 0,
        taskContent: ""
      };
      this.oneTaskData.timeQuantumList = [];
      this.testUserInfo.userId = "";
      this.temporaryStorageDataInit();
      this.inspectionPeriod = [];
    },
    openAddTaskBox(dailyTaskId = "") {
      this.getDepartmentHead(); // 获取部门负责人
      this.getPatrolPoint(dailyTaskId); // 获取巡查点
      this.dateInitialization(); // 日期初始化
      if (this.editState == false) {
        // this.oneTaskData.dailyTaskId = res.data.id
        this.oneTaskData.dailyTaskName = "";
        this.oneTaskData.checkMode = 1;
        this.oneTaskData.regionalPatrolId = 0;
        this.oneTaskData.dailyTaskTimeStatus = 0;
        this.oneTaskData.userId = 0;
        this.oneTaskData.taskType = {
          taskType: 0,
          taskContent: ""
        };
        this.oneTaskData.timeQuantumList = [];
        this.testUserInfo.userId = "";
        this.temporaryStorageDataInit();
        this.inspectionPeriod = [];
        // console.log(this.oneTaskData.taskType);
      }

      this.addTaskDialog = true;
    },
    cancelForm() {
      this.editState = false;
      this.addTaskDialog = false;
      clearTimeout(this.timer);
    },
    searchData() {
      this.requestParams.pageNum = 1;
      this.getDailyInspectionData();
    },
    // 日常巡查翻页
    dailyInspectionPage(val) {
      this.requestParams.pageNum = val;
      this.getDailyInspectionData();
      console.log(`当前页: ${val}`);
    },
    // 删除时间段(新增任务时使用)
    delInspectionPeriod(index) {
      this.inspectionPeriod.splice(index, 1);
    },
    // 更改任务时间类型
    setRaskTimeType(data) {
      this.temporaryStorageDataInit();
      this.oneTaskData.taskType.taskType = this.$store.state.select.taskTimeType[
        this.oneTaskData.dailyTaskTimeStatus
      ].taskTimeTypeList[data].id;
    },
    // 初始化临时存储数据
    temporaryStorageDataInit() {
      this.temporaryStorageData = {
        arrayData: [],
        stringData: ""
      };
      this.inspectionPeriod = [];
      this.oneTaskData.timeQuantums = [];
      this.oneTaskData.timeQuantumList = [];
      this.$nextTick(function() {
        // console.log(this.$refs.selectTree, "=--=-=-=--");
        this.$refs.selectTree.$refs.tree.setCheckedKeys([]);
      });
      this.oneTaskData.taskType.taskContent = "";
      this.selectedPersonList = [];
    },
    // 周任务全选
    weekCheckAll() {
      let data = this.weekInitialization.map((item) => {
        if (!item.disable) {
          return item.dateRange;
        }
      });
      data = data.filter((item) => item);
      let datas = [...this.temporaryStorageData.arrayData, ...data];
      this.temporaryStorageData.arrayData = [...new Set(datas)];
      this.taskDateSelect(this.temporaryStorageData.arrayData);
    },
    //取消全选
    cancelCheckAll() {
      this.temporaryStorageData.arrayData = [];
      this.taskDateSelect([]);
    },
    // 其他时间选择
    taskDateSelect(data) {
      //   this.temporaryStorageDataInit()
      var list = data;
      var listString = list.join(",");
      this.temporaryStorageData.arrayData = data;
      this.temporaryStorageData.stringData = listString;
      this.oneTaskData.taskType.taskContent = listString;
    },
    // 新增时间段(新增任务时使用)
    newTimePeriod() {
      if (this.oneTaskData.regionalPatrolId == 0) {
        this.$message("请先选择巡查点");
        return;
      }
      var insertData = {
        timeArray: ["00:00", "23:59"],
        completeTheWay: 0,
        timeQuantumName: "", // 时间段名称
        quantumStartTime: "00:00", // 开始时间
        quantumEndTime: "23:59", // 结束时间
        userNameArray: "", // 用户名称集合逗号隔开
        userIdArray: "", // 用户名称id集合逗号隔开
        userIdString: []
      };

      this.inspectionPeriod.push(insertData);
    },
    // 日期初始化
    dateInitialization() {
      var _this = this;
      var dataArrat = [];
      if (this.oneTaskData.taskType.taskContent != "") {
        var dataArrat = this.oneTaskData.taskType.taskContent.split(",");
      }

      var taskType = this.oneTaskData.taskType.taskType;
      // 当前年份
      if (this.thisYear == 0) {
        this.thisYear = this.$Common.getThisYear();
      }

      // 初始化星期天数
      this.weekDayList = this.$store.state.select.weekList;

      // 初始化星期
      this.weekInitialization = this.$Common.returnWeek(this.thisYear);

      // 初始化季度
      this.quarterInitialization = this.$Common.createQuarter(this.thisYear);

      // 初始化学期
      this.semesterInitialization = this.$Common.createTerm(this.thisYear);

      // 初始化月
      this.monthInitialization = this.$Common.createMonths(this.thisYear);
    },
    // 选择日常巡查任务
    selectDailyPatrolTask(data) {
      // console.log(data);
      this.ids = data.map((element) => {
        return element.dailyTaskId;
      });
      var list = [];
      var listTwo = [];
      var additionalData = [];
      var strOne = "";
      var strTwo = "";
      data.forEach((item) => {
        list.push(item.dailyTaskId);
        listTwo.push(item.regionalPatrol.regionalPatrolId);
      });
      var temporaryListOne = list;
      strOne = temporaryListOne.join(",");
      var temporaryListTwo = listTwo;
      strTwo = temporaryListTwo.join(",");
      this.batchOperationData.list = list;
      this.batchOperationData.listTwo = listTwo;
      this.batchOperationData.str = strOne;
      this.batchOperationData.strTwo = strTwo;
      // this.batchOperationData.additionalData = additionalData
      // console.log(this.batchOperationData);
    },
    // 选择负责人(新增任务时使用)
    selectDepartmentHead(data) {
      // console.log(this.testUserInfo)
      // console.log(data)
      // console.log(node)
      // var newData = this.$refs.departmentHeadSelect.getCheckedNodes()
      // console.log(newData)
      let value = this.$refs.departmentHeadSelect.panel.getNodeByValue(
        this.testUserInfo.userId
      ).data.thisId;
      // console.log(value)
      // console.log(newData[0].data.thisId);
      this.oneTaskData.userId = value;
      // this.oneTaskData.userId = newData[0].data.thisId
    },
    // 选择巡查人员(新增任务时使用)
    async selectPatrolPersonnel(data) {
      this.oneTaskData.timeQuantums = [];
      // var thisListData = {
      //     nameList:[],
      //     idList:[],
      // }
      // var selectedList = data
      // for(var selectedListKey in selectedList){
      //     var oneKey = selectedList[selectedListKey][0]
      //     var twoKey = selectedList[selectedListKey][1].split('-')[1]

      //     thisListData.nameList.push(this.departmentHead[oneKey].children[twoKey].label)
      //     thisListData.idList.push(this.departmentHead[oneKey].children[twoKey].thisId)
      // }
      // debugger;

      // var formalData = {
      //     userNameArray:thisListData.nameList.join(','),
      //     userIdArray:thisListData.idList.join(','),
      //     completeTheWay:this.patrolPersonnel.completeTheWay,
      //     timeQuantumId:this.patrolPersonnel.timeQuantumId,

      //     // this.oneTaskData.timeQuantumList
      // }
      let userNames = data.map((item) => {
        return item.name;
      });
      let userIds = data.map((item) => {
        return item.id;
      });
      let obj = {
        completeTheWay: this.patrolPersonnel.completeTheWay,
        timeQuantumId: this.patrolPersonnel.timeQuantumId,
        userNameArray: userNames.join(","),
        userIdArray: userIds.join(",")
      };
      this.oneTaskData.timeQuantums.push(obj);
      this.oneTaskData.timeQuantumList.push(obj);
    },

    // 列表选择巡查人员(新增任务时使用)
    selectPatrolPersonnelList(data, index) {
      let userNames = data.map((item) => {
        return item.name;
      });
      let userIds = data.map((item) => {
        return item.id;
      });
      this.inspectionPeriod[index].userNameArray = userNames.join(",");
      this.inspectionPeriod[index].userIdArray = userIds.join(",");
    },
    // 列表选择时间段(新增任务时使用)
    selectTimeSlot(index) {
      this.inspectionPeriod[index].quantumStartTime = this.inspectionPeriod[
        index
      ].timeArray[0];
      this.inspectionPeriod[index].quantumEndTime = this.inspectionPeriod[
        index
      ].timeArray[1];
      // console.log(this.inspectionPeriod[index]);
    },
    isSelectPerson() {
      let a = this.oneTaskData.timeQuantums.findIndex((item) => {
        return item.userIdArray == "";
      });
      if (a > -1) {
        this.$message("请选择时间段 " + (a + 1) + " 的巡查人员");
        return false;
      } else {
        return true;
      }
    },
    // 新增任务
    async newTask() {
      let userList = this.$refs.selectTree.$refs.tree.getCheckedKeys();
      // console.log(userList, "-----------");
      let userList2 = this.$refs.selectTree.$refs.tree.getCheckedNodes();
      // console.log(userList2, "-----------222");
      if (this.oneTaskData.dailyTaskTimeStatus == 0) {
        this.oneTaskData.timeQuantums = this.inspectionPeriod;
      }

      if (this.oneTaskData.dailyTaskName == "") {
        this.$message("请填写任务名称！");
        return;
      }
      if (this.oneTaskData.regionalPatrolId == 0) {
        this.$message("请选择巡查点！");
        return;
      }
      if (this.oneTaskData.userId == 0) {
        this.$message("请选择任务负责人！");
        return;
      }
      if (this.oneTaskData.taskType.taskContent == "") {
        this.$message("请选择时间！");
        return;
      }
      if (this.oneTaskData.dailyTaskTimeStatus == 0) {
        if (this.oneTaskData.timeQuantums.length == 0) {
          this.$message("请选择巡查时段！");
          return;
        }
        if (!this.isSelectPerson()) {
          return;
        }
      }
      if (this.oneTaskData.dailyTaskTimeStatus == 1) {
        if (this.oneTaskData.timeQuantums.length == 0) {
          this.$message("请选择巡查人员");
          return;
        }
      }

      var requestParamsData = {
        dailyTask: {
          schoolId: this.oneTaskData.schoolId,
          dailyTaskName: this.oneTaskData.dailyTaskName,
          regionalPatrolId: this.oneTaskData.regionalPatrolId,
          dailyTaskTimeStatus: this.oneTaskData.dailyTaskTimeStatus,
          userId: this.oneTaskData.userId,
          checkMode: this.oneTaskData.checkMode
        },
        taskType: {
          taskType: this.oneTaskData.taskType.taskType,
          taskContent: this.oneTaskData.taskType.taskContent
        },
        timeQuantums: this.oneTaskData.timeQuantums
      };
      this.addLoading = true
      let res = await this.$Http.newTask(requestParamsData);
      this.addLoading = false
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "新增成功"
        });
        this.clearData();
        this.cancelForm();
        this.getDailyInspectionData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 修改任务
    async editTaskDetails() {
      if (this.oneTaskData.dailyTaskTimeStatus == 0) {
        this.oneTaskData.timeQuantums = this.inspectionPeriod;
      }

      if (this.oneTaskData.dailyTaskName == "") {
        this.$message("请填写任务名称！");
        return;
      }
      if (this.oneTaskData.regionalPatrolId == 0) {
        this.$message("请选择巡查点！");
        return;
      }
      if (this.oneTaskData.userId == 0) {
        this.$message("请选择任务负责人！");
        return;
      }
      if (this.oneTaskData.taskType.taskContent == "") {
        this.$message("请选择时间！");
        return;
      }
      if (this.oneTaskData.dailyTaskTimeStatus == 0) {
        if (this.oneTaskData.timeQuantums.length == 0) {
          this.$message("请选择巡查时段！");
          return;
        }
        if (!this.isSelectPerson()) {
          return;
        }
      }
      if (this.oneTaskData.dailyTaskTimeStatus == 1) {
        if (this.oneTaskData.timeQuantums.length == 0) {
          this.$message("请选择巡查人员");
          return;
        }
      }
      // console.log('--------------')
      // console.log(this.oneTaskData.timeQuantums)
      // console.log('--------------')
      var requestParamsData = {
        dailyTask: {
          dailyTaskId: this.oneTaskData.dailyTaskId,
          dailyTaskName: this.oneTaskData.dailyTaskName,
          regionalPatrolId: this.oneTaskData.regionalPatrolId,
          dailyTaskTimeStatus: this.oneTaskData.dailyTaskTimeStatus,
          userId: this.oneTaskData.userId,
          checkMode: this.oneTaskData.checkMode
        },

        taskType: this.oneTaskData.taskType,
        timeQuantums: this.oneTaskData.timeQuantums
      };
      this.editLoading = true
      let res = await this.$Http.editTaskDetails(requestParamsData);
      this.editLoading = false
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "编辑成功"
        });
        this.clearData();
        this.cancelForm();
        this.getDailyInspectionData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取任务详情
    async getTaskDetails(id) {
      this.editState = true;
      var paramData = {
        schoolId: this.requestParams.schoolId,
        dailyTaskId: id
      };
      let res = await this.$Http.getTaskDetails(paramData, true);
      if (res.code == 200) {
        this.oneTaskData.timeQuantums = [];
        this.oneTaskData.timeQuantumList = [];
        this.oneTaskData.dailyTaskId = res.data.dailyTaskId;
        this.oneTaskData.dailyTaskName = res.data.dailyTaskName;
        this.oneTaskData.checkMode = res.data.checkMode;
        this.oneTaskData.regionalPatrolId =
          res.data.regionalPatrol.regionalPatrolId;
        this.oneTaskData.dailyTaskTimeStatus = res.data.dailyTaskTimeStatus;
        this.oneTaskData.userId = res.data.userId;
        this.oneTaskData.taskType = {
          taskType: res.data.taskType.taskType,
          taskContent: res.data.taskType.taskContent,
          dailyTaskId: res.data.dailyTaskId
        };
        this.oneTaskData.timeQuantumList = [];
        if (
          res.data.dailyTaskTimeStatus == 1 &&
          res.data.timeQuantumList.length >= 1
        ) {
          this.patrolPersonnel.completeTheWay =
            res.data.timeQuantumList[0].completeTheWay;
          this.patrolPersonnel.userNameArray =
            res.data.timeQuantumList[0].userNameArray;
          this.patrolPersonnel.userIdArray =
            res.data.timeQuantumList[0].userIdArray;
          this.patrolPersonnel.timeQuantumId =
            res.data.timeQuantumList[0].timeQuantumId;
          this.oneTaskData.timeQuantums.push(this.patrolPersonnel);
          this.oneTaskData.timeQuantumList.push(this.patrolPersonnel);
          let ids = res.data.timeQuantumList[0].userIdArray.split(",");
          this.$nextTick(function() {
            this.$refs.selectTree.$refs.tree.setCheckedKeys(ids);
          });
        } else if (
          res.data.dailyTaskTimeStatus == 0 &&
          res.data.timeQuantumList.length >= 1
        ) {
          this.oneTaskData.timeQuantumList = res.data.timeQuantumList;
          this.inspectionPeriod = [];
          this.oneTaskData.timeQuantumList.forEach((element, index) => {
            this.$nextTick(function() {
              let ids = element.userIdArray.split(",");
              this.$refs[
                `patrolPersonnelSelect${index}`
              ][0].$refs.tree.setCheckedKeys(ids);
            });

            this.inspectionPeriod.push({
              timeArray: [element.quantumStartTime, element.quantumEndTime],
              quantumStartTime: element.quantumStartTime,
              quantumEndTime: element.quantumEndTime,
              timeQuantumId: element.timeQuantumId,
              userIdArray: element.userIdArray,
              userNameArray: element.userNameArray,
              completeTheWay: element.completeTheWay,
              userIdString: []
            });
          });
        }

        this.temporaryStorageData.arrayData = res.data.taskType.taskContent.split(
          ","
        );
        this.openAddTaskBox(this.oneTaskData.dailyTaskId);
        // console.log(this.temporaryStorageData.arrayData)
        // console.log(this.oneTaskData.timeQuantumList)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取巡查点（新增巡查任务时需要）
    async getPatrolPoint(dailyTaskId = "") {
      var paramData = {
        schoolId: this.requestParams.schoolId,
        dailyTaskId: dailyTaskId
      };
      let res = await this.$Http.getPatrolPoint(paramData, true);
      if (res.code == 200) {
        this.patrolPointList = res.data;
      } else if (res.code == 101) {
        this.patrolPointList = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取部门及负责人（新增巡查任务时需要）
    async getDepartmentHead() {
      var _this = this;
      var paramData = {
        schoolId: this.requestParams.schoolId
      };
      let res = await this.$Http.getDepartmentHead(paramData, true);
      if (res.code == 200) {
        // this.departmentHead = res.data
        _this.selectedPersonList = [];
        var departmentHeadList = [];
        for (var keyOne in res.data) {
          var thisUserList = [];
          for (var keyTwo in res.data[keyOne].dlist) {
            // 负责人默认选择
            if (
              this.oneTaskData.userId == res.data[keyOne].dlist[keyTwo].userId
            ) {
              this.testUserInfo.userId = [];
              this.testUserInfo.userId.push(keyOne);
              this.testUserInfo.userId.push(keyOne + "-" + keyTwo);
            }

            // 巡查人员默认选择
            if (
              this.oneTaskData.dailyTaskTimeStatus == 1 &&
              this.oneTaskData.timeQuantumList.length >= 1
            ) {
              var selectedUserInfo = Object.assign(
                {},
                this.oneTaskData.timeQuantumList[0]
              );
              var selectedUserList = selectedUserInfo.userIdArray
                ? selectedUserInfo.userIdArray.split(",")
                : [];
              selectedUserList.forEach((element) => {
                if (element == res.data[keyOne].dlist[keyTwo].userId) {
                  var personUserGroup = [];
                  personUserGroup.push(keyOne);
                  personUserGroup.push(keyOne + "-" + keyTwo);
                  _this.selectedPersonList.push(personUserGroup);
                }
              });
            } else if (
              this.oneTaskData.dailyTaskTimeStatus == 0 &&
              this.oneTaskData.timeQuantumList.length >= 1
            ) {
              for (var i = 0; this.inspectionPeriod.length > i; i++) {
                var selectedUserList = this.inspectionPeriod[i].userIdArray
                  ? this.inspectionPeriod[i].userIdArray.split(",")
                  : [];
                selectedUserList.forEach((element) => {
                  if (element == res.data[keyOne].dlist[keyTwo].userId) {
                    var personUserGroup = [];
                    personUserGroup.push(keyOne);
                    personUserGroup.push(keyOne + "-" + keyTwo);
                    this.inspectionPeriod[i].userIdString.push(personUserGroup);
                  }
                });
              }
            }

            var newThisData = {
              value: keyOne + "-" + keyTwo,
              label: res.data[keyOne].dlist[keyTwo].userName,
              thisId: res.data[keyOne].dlist[keyTwo].userId,
              thisLevel: 2
            };
            thisUserList.push(newThisData);
          }

          departmentHeadList[keyOne] = {
            value: keyOne,
            label: res.data[keyOne].departmentName,
            thisId: res.data[keyOne].departmentId,
            thisLevel: 1,
            children: thisUserList
          };
        }
        this.departmentHead = departmentHeadList;
        // console.log(this.inspectionPeriod)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async dailyInspectionBathHide() {
      if (this.batchOperationData.str == "") {
        this.$message("请先选择要删除的数据！");
        return;
      }
      this.$confirm("此操作将删除此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let req = {
            ids: [this.batchOperationData.str]
          };
          let res = await this.$Http.dailyInspectionHide(req, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.messsage
            });

            this.getDailyInspectionData();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    async dailyInspectionHide(id) {
      this.$confirm("此操作将删除此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let req = {
            ids: [id]
          };
          let res = await this.$Http.dailyInspectionHide(req, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.messsage
            });

            this.getDailyInspectionData();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    // 删除日常巡查(不保留巡查记录)
    async dailyInspectionDelete(thisData = "") {
      this.$confirm("此操作将永久删除此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var paramData = {
            dailytasklist: this.batchOperationData.list,
            updatelist: this.batchOperationData.listTwo
          };

          if (thisData) {
            var paramData = {
              dailytasklist: [],
              updatelist: []
            };
            paramData.dailytasklist.push(thisData.dailyTaskId);
            paramData.updatelist.push(thisData.regionalPatrolId);
          }
          const loading = this.$loading({
            lock: true,
            text: "数据删除中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          let res = await this.$Http.dailyInspectionDelete(paramData);
          if (res.code == 200) {
            loading.close();
            this.$message({
              type: "success",
              message: res.messsage
            });
            this.batchOperationData = {
              list: [],
              str: "",
              additionalData: []
            };

            this.getDailyInspectionData();
          } else if (res.code == 101) {
          } else {
            loading.close();
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    // 批量删除日常巡查(不保留巡查记录)
    async dailyInspectionBathDelete(thisData = "") {
      if (!thisData & (this.batchOperationData.listTwo.length < 1)) {
        this.$message("请先选中您要删除的任务！");
        return;
      }
      this.$confirm("此操作将永久删除此条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var paramData = {
            dailytasklist: this.batchOperationData.list,
            updatelist: this.batchOperationData.listTwo
          };

          if (thisData) {
            var paramData = {
              dailytasklist: [],
              updatelist: []
            };
            paramData.dailytasklist.push(thisData.dailyTaskId);
            paramData.updatelist.push(thisData.regionalPatrolId);
          }
          const loading = this.$loading({
            lock: true,
            text: "数据删除中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          let res = await this.$Http.dailyInspectionDelete(paramData);
          if (res.code == 200) {
            loading.close();
            this.$message({
              type: "success",
              message: res.messsage
            });
            this.batchOperationData = {
              list: [],
              str: "",
              additionalData: []
            };

            this.getDailyInspectionData();
          } else if (res.code == 101) {
          } else {
            loading.close();
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },
    deleteTimePeriod(key) {
      // console.log(key)
      let tempArray = this.inspectionPeriod;
      tempArray.splice(key, 1);
      this.inspectionPeriod = tempArray;
    },

    // 删除时间段
    // async deleteTimePeriod(indexKey=''){
    //     if(this.editState == false){
    //         this.inspectionPeriod.splice(indexKey,1)
    //     }
    //     this.$confirm('此操作将永久删除此条数据, 是否继续?', '提示', {
    //         confirmButtonText: '确定',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //     }).then(async () => {
    //         const loading = this.$loading({
    //                 lock: true,
    //                 text: '数据删除中...',
    //                 spinner: 'el-icon-loading',
    //                 background: 'rgba(0, 0, 0, 0.7)'
    //         });
    //         var paramData = {
    //             timeQuantumId:this.inspectionPeriod[indexKey].timeQuantumId,
    //         }

    //         let res = await  this.$Http.deleteTimePeriod(paramData,true)
    //         if(res.code == 200){
    //             this.inspectionPeriod.splice(indexKey,1)
    //             loading.close();
    //             this.$message({
    //                 type: 'success',
    //                 message: res.messsage
    //             });

    //         }else if(res.code == 101){

    //         } else {
    //             loading.close();
    //             this.$message({
    //                 type: 'error',
    //                 message: res.messsage
    //             });
    //         }

    //     }).catch(() => {});

    // },
    // 日常巡查批量启用
    async dailyInspectionBatchEnable(id = "") {
      if (!id & (this.batchOperationData.list.length < 1)) {
        this.$message("请先选中您要启用的任务！");
        return;
      }
      var paramData = {
        batchopenstatelist: this.batchOperationData.list
      };

      // var paramData = this.batchOperationData.list
      if (id) {
        var paramData = {
          batchopenstatelist: []
        };
        paramData.batchopenstatelist.push(id);
      }
      let res = await this.$Http.dailyInspectionBatchEnable(paramData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.batchOperationData.list = [];
        this.batchOperationData.str = "";
        this.getDailyInspectionData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 日常巡查批量禁用
    async dailyInspectionBatchDisable(id = "") {
      if (!id & (this.batchOperationData.list.length < 1)) {
        this.$message("请先选中您要禁用的任务！");
        return;
      }

      var paramData = {
        batchclosestatelist: this.batchOperationData.list
      };

      if (id) {
        var paramData = {
          batchclosestatelist: []
        };
        paramData.batchclosestatelist.push(id);
      }

      let res = await this.$Http.dailyInspectionBatchDisable(paramData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.batchOperationData.list = [];
        this.batchOperationData.str = "";
        this.getDailyInspectionData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取日常巡查数据
    async getDailyInspectionData() {
      var paramData = {
        schoolId: this.requestParams.schoolId,
        pageNum: this.requestParams.pageNum,
        pageSize: this.requestParams.pageSize,
        dailyTaskName: this.requestParams.dailyTaskName,
        regionalPatrolSite: this.requestParams.regionalPatrolSite
      };
      let res = await this.$Http.getDailyInspectionData(paramData, true);
      if (res.code == 200) {
        this.dailyInspectionData.pageNum = res.data.pageNum; // 第几页
        this.dailyInspectionData.pageSize = res.data.pageSize; // 一页多少个
        this.dailyInspectionData.totalSize = res.data.total; // 总条数
        this.dailyInspectionData.totalPages = res.data.pages; // 总页数
        this.dailyInspectionData.list = res.data.list; // 数据列表
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 导出巡查任务
    async exportReport() {
      let schoolId = Number(sessionStorage.getItem("schoolId"));
      let req = {
        schoolId: schoolId
      };
      this.$Common.exportData(req, "exportPatrolTask", "巡查任务", false);
    },
  },
  created() {},
  mounted() {
    this.getDailyInspectionData();
  }
};
</script>
<style scoped></style>
